import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useI18n } from "@/lib/i18n";

const T = {
  fr: { msg: "Page introuvable.", back: "Retour à l'accueil" },
  de: { msg: "Seite nicht gefunden.", back: "Zur Startseite" },
  en: { msg: "Page not found.", back: "Back to home" },
};

export default function NotFound() {
  const { lang } = useI18n();
  const t = T[lang] || T.fr;
  return (
    <div className="min-h-screen bg-[#F7F7F8]">
      <Header />
      <main className="pt-36 pb-20 text-center px-4">
        <div className="max-w-md mx-auto">
          <div className="text-7xl font-extrabold text-[#2D5BFF]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>404</div>
          <p className="mt-4 text-[#4B5563]">{t.msg}</p>
          <Link to="/" className="mt-6 inline-block rounded-full bg-[#2D5BFF] text-white px-6 py-3 font-semibold" data-testid="notfound-home">{t.back}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
